import styled from 'styled-components';

export const Container = styled.div`
  display: inline-block;
  cursor: pointer;
`;

export const Circle = styled.div`
  width: 14px;
  height: 14px;
  background-color: #0d3567;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NumberQty = styled.span`
  display: block;
  color: white;
  font-size: 10px;
`;
